module.exports = __webpack_public_path__ + "images/28622fe42a76a4fe31fea9baded023ae.jpg";